import React from 'react'
import { Modal } from 'react-bootstrap'
import Back from 'assets/images/svg/back_blue.svg';
import { t } from 'i18next';
import { appLicensesSourceAtom } from '../pages/lincenses.store';
import { useRecoilValue } from 'recoil';
import { toast } from 'react-toastify';
import { useStatus } from 'hooks/use-status';
import { callAll } from 'helpers/misc';
import { useServerErrors } from 'hooks/use-server-errors';
import { Button, Form, InputField } from 'components/form';
import { useParams } from 'react-router-dom';
import { useQueryClient } from 'react-query';

const AddDevice = ({ show, onHide, ...props }) => {
    const { isLoading, load, done, stop } = useStatus()
    const [serverErrors, setServerErrors] = useServerErrors()
    const { id } = useParams()
    const queryClinet = useQueryClient()

    const appLicensesSource = useRecoilValue(appLicensesSourceAtom(id))

    const success = () => {
        done()
        appLicensesSource.reload()
        onHide()
        toast.success(t('common:form.added'))
        queryClinet.refetchQueries('product')
    }
 

    const handleRequest = data => {
        
        appLicensesSource.store().insert({...data,VersionSubscriptionId:id}).then(()=>{success()}).catch(callAll(stop, setServerErrors))
    }
  
    return (
        <div>
            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={show}
                onHide={onHide}
                className="all-modal changeNumber"
            >
                <Modal.Body>
                    <div className="header">
                        <img src={Back} alt="back" onClick={onHide} />
                        <h1>
                               { t('browse-apps:myProducts.productLicense.addDevice')}
                        </h1>
                    </div>
                    <Form
                        className="row"
                        onSubmit={handleRequest}
                        defaultValues={{
                            deviceName:'',
                            serialNumber:'',
                        }}
                    >
                        {({ watch }) => {
                            return (
                                <>
                                    <div className="col-md-12">
                                       
                                        <InputField
                                            label={t('browse-apps:myProducts.productLicense.deviceCol')}
                                            id="deviceName"
                                            rules={{
                                                required: 'errors:required'}}

                                        />
                                    </div>
                                    <div className="col-md-12">
                                       
                                       <InputField
                                           label={t('browse-apps:myProducts.productLicense.serialcol')}
                                           serverError={serverErrors?.serialNumber}
                                           id="serialNumber"
                                           rules={{ required: 'errors:required' }}

                                       />
                                   </div>

                                    <div className="col-12">
                                        <Button
                                            type="submit"
                                            className="btn-blue mt-4"
                                            isLoading={isLoading}
                                        >
                               { t('browse-apps:myProducts.productLicense.addDevice')}
                                        </Button>
                                    </div>
                                </>
                            )
                        }}
                    </Form>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default AddDevice